/*

    Module: jv.common.barchart.directive
    Directive: jv-barchart

    Usage:
        <div jv-barchart></div>

    Data:
        [
            {
                label:
            }
        ]
 */

angular.module('jv.common.barchart.directive', ['chart.js'])
.directive('jvBarchart', [
    function() {
        var options = {
            responsive: true,
            animationEasing: 'easeOutCirc',
            animationSteps: 30
        };
        // have to put css colors in here
        // TODO: find a way to read them from css
        var colors = [
            '#38b24a',
            '#e51414',
            '#f57d21',
            '#7354bd',
            '#3d87cf',
            '#38b24a',
            '#f01978',
            '#b8d3ed',
            '#f9b683',
            '#f679b0',
            '#cdc2e8'
        ];

        var pastelColors = [
            '#3d87cf',
            '#f57d21',
            '#38b24a',
            '#f9b683',
            '#f679b0',
            '#cdc2e8'
        ];
        return {
            scope: {
                barchartSubtitle: '@',
                barchartData: '=',
            },
            link: function(scope, element, attrs) {
                var offset = 0;
                var chart;

                scope.labels = [];
                scope.data = [];

                var data = [];
                scope.barchartData.forEach(function(piece, index) {
                    scope.labels.push(piece.value);
                    data.push(piece.count);
                });

                scope.data.push(data);

                scope.options = angular.copy(options);
                scope.colors = angular.copy(colors);

                scope.handleClick = function() {
                    chart.render();
                }
                scope.$on('create', function(event, c) {
                    chart = c;
                });
            },
            template: '<div class="jv-timeseries"><canvas chart-bar chart-data="data" chart-labels="labels" chart-options="options" chart-colours="colors" chart-click="handleClick" height="100%"></canvas></div>'
        }
    }
])
